/*
 * N49 Framework
 * 2020-2021
 */

(function ($) {

    let N49 = {

        debug: false,
        ajaxURL: "//" + location.host + "/wp-admin/admin-ajax.php",

        init: function (debug = false) {

            this.debug = debug;

            // N49 Archive
            this.handle__ajax();
            this.handle__archive();
            //
            this.handle__form();
            this.handle__header();
            this.handle__carousel();
            this.handle__compare();
            this.handle__packets();
            this.handle__video();
            this.handle__faq();

        },

        handle__faq: function () {
        $('.faq__header-toggle').click(function () {
            var item = $(this).closest('.faq__item'), description = item.find('.faq__description');
            item.toggleClass('active');
            if (item.hasClass('active')) {
                description.slideDown();
            } else {
                description.slideUp();
            }
            return false;
        });
        $('.faq__question-title, .faq__question-toggle').click(function () {
            var question = $(this).closest('.faq__question'), answer = question.find('.faq__question-answer');
            question.toggleClass('active');
            if (question.hasClass('active')) {
                answer.slideDown();
            } else {
                answer.slideUp();
            }
            return false;
        });
    },

        handle__video: function () {
        $('.video').each(function () {
            var video = $(this), play = $('.video__play', video), preview = $('.video__preview', video), iframe = $('iframe', video);
            play.on('click', function () {
                video.addClass('play');
                iframe[0].src += '&autoplay=1';
                setTimeout(function () {
                    play.fadeOut();
                    preview.fadeOut();
                }, 300);
                return false;
            });
        });
    },

        handle__packets: function () {
        var _this = $('.packets'), slider = $('.packets__slider', _this);
        slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            mobileFirst: true,
            adaptiveHeight: true,
            dots: false,
            arrows: true,
            prevArrow: '<span class="slick-prev"/>',
            nextArrow: '<span class="slick-next"/>',
            responsive: [{
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            }]
        });
    },

        handle__compare: function () {
        var _this = $('.compare'), win = $(window), slider = $('.compare__list', _this);

        win.on('resize', function () {
            var viewportWidth = $(window).width();
            if ((viewportWidth < 767) && (!slider.hasClass('slick-initialized'))) {
                slider.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    mobileFirst: true,
                    adaptiveHeight: true,
                    fade: true,
                    dots: true,
                    arrows: false,
                    customPaging: function () {
                        return '<span class="slick-dot"/>';
                    },
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: 'unslick'
                        }
                    ]
                });
            }
        }).resize();
    },

        handle__carousel: function () {
        var carousel = $('.carousel');
        $('.carousel__slider', carousel).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            mobileFirst: true,
            adaptiveHeight: true,
            dots: true,
            prevArrow: '<span class="slick-prev"/>',
            nextArrow: '<span class="slick-next"/>',
            arrows: false,
            customPaging: function () {
                return '<span class="slick-dot"/>';
            },
            responsive: [{
                breakpoint: 767,
                settings: {
                    variableWidth: true
                }
            }, {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    variableWidth: true,
                    arrows: true,
                    dots: false
                }
            }]
        });
    },

        handle__form: function () {
        $('.select').selectric({
            disableOnMobile: false,
            nativeOnMobile: false
        });
    },

        handle__header: function () {
        function searchClick(e) {
            if ($(e.target).closest('.header__search').length === 0) {
                search.removeClass('open');
                setTimeout(function () {
                    search.removeClass('visible');
                }, 250);
            }
        }

        var nav = $('.header__nav'), search = $('.header__search'), body = $('body'), win = $(window);

        function preventMotion(event) {
            event.preventDefault();
            event.stopPropagation();
        }

        $('.header__toggle', nav).on('click', function () {
            if (nav.hasClass('visible')) {
                setTimeout(function () {
                    nav.removeClass('open');
                    body.removeClass('menu-open');
                    win.off('scroll', preventMotion);
                    win.off('touchmove', preventMotion);
                    setTimeout(function () {
                        nav.removeClass('visible');
                        search.removeClass('open').removeClass('visible');
                    }, 250);
                }, 25);
            } else {
                nav.addClass('visible');
                $(".social").css('display', "flex");
                setTimeout(function () {
                    nav.addClass('open');
                }, 25);
                setTimeout(function () {
                    body.addClass('menu-open');
                    win.on('scroll', preventMotion, false);
                    win.on('touchmove', preventMotion, false);
                }, 300);
            }
            return false;
        });

        $('.header__search-toggle').on('click', function () {
            if (search.hasClass('visible')) {
                setTimeout(function () {
                    search.removeClass('open');
                    body.off('click', searchClick);
                    setTimeout(function () {
                        search.removeClass('visible');
                    }, 250);
                }, 25);
            } else {
                search.addClass('visible');
                setTimeout(function () {
                    search.addClass('open');
                    body.on('click', searchClick);
                }, 25);
            }
            return false;
        });

            const sectionHeroEl = document.querySelector(".header");

            const obs = new IntersectionObserver(
                function (entries) {
                    const ent = entries[0];
                    console.log(ent);

                    if (ent.isIntersecting === false) {
                        document.body.classList.add("sticky");
                    }

                    if (ent.isIntersecting === true) {
                        document.body.classList.remove("sticky");
                    }
                },
                {
                    // In the viewport
                    root: null,
                    threshold: 0,
                    rootMargin: "-185px",
                }
            );
            obs.observe(sectionHeroEl);
    },



    handle__ajax: function () {
            $('.js--archive-ajax').ajaxArchive({
                ajax_base_url: N49.ajaxURL,
            });
    },

    handle__archive: function () {

            /*
            // Custom dropdown
            $(".js--dropdown-1").ddslick({
                onSelected: function (selectedData) {
                    //callback function: do something with selectedData;
                },
            });
            */


            /*
            // Search istop


            $(".search-items-parent .dd-option-text").click(function () {
                var data = "." + $(this).text().toLowerCase(); // <<<<<< dropdown item text
                var filterData = data.replace(" ", "-");
                if (filterData == ".select-filter") {
                    // <<<<< if dropdown item text == Select Filter
                    filterData = "*";
                }
                $("#js--blog-search-list").isotope({
                    filter: filterData,
                });
            });
             */

            // search blog list
            const searchBlogInput = document.querySelector(".item-search-input input");
            const blogItem = document.querySelectorAll(".articles__entry");

            var searchInputValue;

            if (searchBlogInput !== null) {
                searchBlogInput.addEventListener("input", (e) => {
                    searchInputValue = e.target.value.toLowerCase();

                    if (searchInputValue == "") {
                        for (let i = 0; i < blogItem.length; i++) {
                            blogItem[i].style.display = "block";
                        }
                    }

                    for (let i = 0; i < blogItem.length; i++) {
                        var blogItemTitle = blogItem[i].getElementsByTagName("h4")[0];

                        /*
                        $("#js--blog-search-list").isotope({
                            filter: "*", //  cancel dropdown filtering
                        });
                         */

                        if (blogItemTitle.innerHTML.toLowerCase().indexOf(searchInputValue) != -1) {
                            blogItem[i].style.display = "block";
                        } else {
                            blogItem[i].style.display = "none";
                        }
                    }
                });
            }
        },
    };


    let Elementor_N49 = {
        initHeroSlider: function () {
            function slider(direction) {
                const swiper = new Swiper(".js--swiper", {
                    // Optional parameters
                    direction: direction,
                    loop: true,

                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                });
            }

            function mobileSLider(x) {
                if (x.matches) {
                    slider("horizontal");
                } else {
                    slider("vertical");
                }
            }

            var x = window.matchMedia("(max-width: 700px)");
            mobileSLider(x);
            x.addListener(mobileSLider);

// Galery slider
            const swiper = new Swiper(".js--mobile-gallery-slider", {
                loop: true,
                pagination: {
                    el: ".swiper-pagination",
                },
            });

        },
    };


    N49.init();


    $(window).on('elementor/frontend/init', function () {
        //hook name is 'frontend/element_ready/{widget-name}.{skin} - i dont know how skins work yet, so for now presume it will
        //always be 'default', so for example 'frontend/element_ready/slick-slider.default'
        //$scope is a jquery wrapped parent element

        elementorFrontend.hooks.addAction('frontend/element_ready/n49__hero.default', function ($scope, $) {
            Elementor_N49.initHeroSlider();
        });



    });


}(jQuery));